@if (service.loaded()) {
  @if (service.found()) {
    <div>
      <mat-card class="borgo-kyc-container"
                [class]="{'borgo-kyc-container-applicant': currentStep() === 1}">

        <h1 id="kyc-heading"
            class="borgo-title"
        >Borgo kundkännedom</h1>
        <div class="progress-bar-container">
          <mat-progress-bar
            mode="determinate"
            [value]="(currentStep() -1) * (1 / (totalSteps - 1)) * 100"
            aria-labelledby="kyc-heading"/>

          <div class="step-counter">{{ currentStep() }}/{{ totalSteps }}</div>
        </div>

        <div class="kyc-container">

          @switch (currentStep()) {
            @case (1) {
              <spb-applicant #step/>
              <div class="navigation-buttons">
                <button
                  matButton="filled"
                  (click)="nextStep()"
                  [disabled]="!step.valid()"
                >Nästa
                </button>
              </div>
            }
            @case (2) {
              <spb-citizenship #step/>
              <div class="navigation-buttons">
                <button (click)="previousStep()"
                        matButton="outlined">
                  Föregående
                </button>
                <button
                  matButton="filled"
                  (click)="nextStep()"
                  [disabled]="!step.valid()"
                >Nästa
                </button>
              </div>
            }
            @case (3) {
              <spb-tax-residency #step/>
              <div class="navigation-buttons">
                <button (click)="previousStep()"
                        matButton="outlined">
                  Föregående
                </button>
                <button
                  matButton="filled"
                  (click)="nextStep()"
                  [disabled]="!step.valid()"
                >Nästa
                </button>
              </div>
            }
            @case (4) {
              <spb-employment #step/>
              <div class="navigation-buttons">
                <button (click)="previousStep()"
                        matButton="outlined">
                  Föregående
                </button>
                <button
                  matButton="filled"
                  (click)="nextStep()"
                  [disabled]="!step.valid()"
                >Nästa
                </button>
              </div>
            }
            @case (5) {
              <spb-pep #step/>
              <div class="navigation-buttons">
                <button (click)="previousStep()"
                        matButton="outlined">
                  Föregående
                </button>
                <button
                  matButton="filled"
                  (click)="nextStep()"
                  [disabled]="!step.valid()"
                >Nästa
                </button>
              </div>
            }
            @case (6) {
              @if (errorMessage()) {
                <div class="error-message">
                  <p>
                    Något gick fel. Vänligen gå tillbaka och kontrollera dina
                    uppgifter.

                  </p>
                  <p>Har du frågor är du välkommen att kontakta vårt kundcenter,
                    <a
                      spbAccessibleLink
                      href="https://www.sparbankensyd.se/sv/om-oss/kontakt"
                      target="_blank">klicka här för kontaktinformation</a>.
                  </p>
                </div>
              } @else {
                <spb-approve [(data)]="approvalData"/>
              }
              <div class="navigation-buttons">
                <button (click)="previousStep();approvalData.set(false)"
                        matButton="outlined">
                  Föregående
                </button>
                <button
                  matButton="filled"
                  (click)="signLink()"
                  [disabled]="approvalData() !== true"
                >Granska och godkänn
                </button>
              </div>

            }
          }
        </div>
      </mat-card>
    </div>
    <div class="logout">
      <button
        matButton="outlined"
        (click)="configService.logout()">Ny person
      </button>
    </div>
  } @else {
    <div class="no-user borgo-kyc-container">
      <div [style.margin-bottom.rem]="0.75">
        <p>Något gick fel. Vi kan inte hitta dina uppgifter. Troligen har du inte
          ett bolån hos vår samarbetspartner Borgo.</p>
        <p> Om du har ett bolån men är osäker på vem som är kreditgivare, kan du
          se det i internetbanken.</p>
        <p>Har du frågor är du välkommen att kontakta vårt kundcenter,
          <a
            spbAccessibleLink
            href="https://www.sparbankensyd.se/sv/om-oss/kontakt"
            target="_blank">klicka här för kontaktinformation</a>.
        </p>
      </div>
      <button (click)="configService.logout()" matButton="elevated">
        Testa igen
      </button>
    </div>
  }
} @else {
  <spb-please-wait/>
}
